import React, { useState, useContext, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Store } from '../../components/utils/Store'
import createAxiosInstance from '../axios/axiosCustom';
import AutoComplete from '../elements/Autocomplete';
import DatePickerCustom from '../elements/DatePickerCustom';
// import Maps from '../maps/Maps';
import { ArchiveIcon, TrashIcon } from '../../assets/icons/IconComponents'
import Modal from '../modal/Modal';
// import UserConnections from '../common/UserConnections';
import { useNotification } from '../utils/Notification';
// import createChatMessage from '../../utils/createChatMessage';
import { eventDefaultData } from '../utils/defaultValues';
import { validateForm } from '../utils/validations';
import uploadFile, {setBase64File} from '../utils/uploadFile';
import AutoCompleteAdress from '../elements/AutocompleteAdress';


function EventEditor({id, callback}) {
  const notification = useNotification()
  const { dispatch, state } = useContext(Store)
  const { typeData,  categoryData } = state
  
  const { t } = useTranslation()

  const modalRef = useRef(null)
  const formRef = useRef(null)
  const imgRef = useRef(null)

  const [event, setEvent] = useState(eventDefaultData())

  const [typeOpts, setTypeOpts] = useState([])
  const [categoryOpts, setCategoryOpts] = useState([])
  
  const [usersList, setUsersList] = useState([])
  const [chatVisible, setChatVisible] = useState(false)
  const [chatReqSent, setChatReqSent] = useState(false)
  const [hasImg, setHasImg] = useState(false)
  const [coverPic, setCoverPic] = useState('')

  const [ conditions, setConditions ] = useState({
    showDelete: false,
    showArchive: false
  })
  
  const moodOpts = [
    {id: 'CASUAL', name: t('casual')},
    {id: 'COMPETITIVE', name: t('competitive')},
    {id: 'FOCUSED', name: t('focused')},
  ]

  const genderOpts = [
    {id: 'MALE', name: t('male')},
    {id: 'FEMALE', name: t('female')},
    {id: 'OTHER', name: t('other')},
  ]

  const privacyOptionOpts = [
    {id: 'PRIVATE', name: t('private')},
    {id: 'PUBLIC', name: t('public')},
    {id: 'HIDDEN', name: t('hidden')},
  ]

  const paidByOpts = [
    {id: 'group', name: t('group')},
    {id: 'person', name: t('person')},
  ]

  const getEvent = async (id) => {
    if(!id || id == 0) {
      setEvent(eventDefaultData())
      doEdit()
      return
    }

    const axiosCustom = await createAxiosInstance()
    let resp = await axiosCustom.get('/event/'+id)
    setEvent(resp?.data || eventDefaultData())
    doEdit(resp?.data || '')
  }

  const doEdit = async (data) => {
    if(data){
      let categoryList = categoryData ? categoryData.filter(item => item.typeId == data.type._id) : []
      setCategoryOpts(categoryList)
      
      if(data?.participantsFilter?.gender) toObj('participantsFilter', 'gender', data.participantsFilter.gender)
      if(data?.participantsFilter?.minAge) toObj('participantsFilter', 'minAge', data.participantsFilter.minAge)

      setTypeAndCategory(data)
    } 


    setHasImg((data?.coverPic?.id || data?.coverPic?.mimetype) ? true : false)
    setCoverPic(data?.coverPic || '')
    if(imgRef?.current) {
      imgRef.current.src = data?.coverPic?.url || ''
    }

    onSelectTab('', 'general')
    setConditions({
      showDelete: data?._id && !data.isDeleted ? true : false,
      showArchive: data?._id && !data.isDeleted ? true : false,
    })
  }

  const onSave = async () => {
    const formElements = formRef.current.elements
    let isValid = validateForm(formElements)
    if(!isValid) {
      return
    } 

    if(event._id == 0) {
      await onCreateNew(event)
      
    } else {
      await onUpdate(event)
    } 
  }

  const onCreateNew = async (event) => {
    if(coverPic) {
      let res = await uploadFile(coverPic)
      if(res.data){
        let responseData = res.data.data
        event.coverPic = {id: responseData.id, name: responseData.name, url: responseData.url}
      } 
    }

    const axiosCustom = await createAxiosInstance()
    await axiosCustom.post('/event/create', event)

    // console.warn({m:'create', event, coverPic})
    callback('save')
    dispatch({ type: 'EVENT_EDIT', payload: null })
    notification.show(t('succesfully_saved'))
  }

  const onUpdate = async (event) => {
    if(coverPic && !coverPic.id) {
      let res = await uploadFile(coverPic)
      if(res.data){
        let responseData = res.data.data
        event.coverPic = {id: responseData.id, name: responseData.name, url: responseData.url}
      } 
    }

    const axiosCustom = await createAxiosInstance()
    await axiosCustom.put('/event/'+event._id, event)

    // console.warn({m:'upd', event, coverPic})
    callback('save')
    dispatch({ type: 'EVENT_EDIT', payload: null })
    notification.show(t('succesfully_saved'))
  }

  const onCancel = () => {
    callback('cancel')
    dispatch({ type: 'EVENT_EDIT', payload: null })
  }
  
  const setEventState = (val, key) => {
    if(['gender', 'minAge'].includes(key)){
      toObj('participantsFilter', key, val)
      return
    }

    setEvent({
      ...event,
      [key]: val
    })
  }

  const toObj = (obj, key, val) => {
    setEvent(prevState => ({
      ...prevState,
      [obj]: {
        ...prevState[obj],
        [key]: val
      }
    }))
  }

  const setTypeAndCategory = (data) => {
    let category = JSON.parse(data.category)
    
    setEvent(prevState => ({
      ...prevState,
      type: data.type._id,
      category: category.id
    }))
  }

  const setCategoryList = (id) => {
    let categoryList = id && categoryData ? categoryData.filter(item => item.typeId == id) : []
    setCategoryOpts(categoryList)  
    
    if(event.category) {
      setEventState(event.category, 'category')
    } 
  }

  const onSelectTab = (e, name) => {
    let selectedName = name || e?.target.getAttribute('name')
    let selectContent = modalRef.current.querySelector(`#content\\.${selectedName}`)
    if(!selectContent) {
      return
    }

    if(e?.target?.parentNode) {
      let parent = e.target.parentNode
      let tabs = parent.children
      for(let tab of tabs) {
        tab.removeAttribute('selected')
      }
    }

    if(name) {
      let tab = document.querySelector(`[name="${name}"]`)
      tab.setAttribute('selected', true)

    } else {
      e.target.setAttribute('selected', true)
    }
    
    let contents = modalRef.current.querySelectorAll('.content-list')
    for(let content of contents) {
      content.setAttribute('hidden', true)
    }

    selectContent.removeAttribute('hidden')
  }

  const removeImg = (e) => {
    setHasImg(false)
  }

  const onChangeImg = async (evt) => {
    const file = evt.files[0]
    if(!file.type.includes('image/')) {
      return
    }

    setHasImg(true)
    
    setTimeout(() => {
      const objectURL = URL.createObjectURL(file)    
      imgRef.current.src = objectURL
    }, 500)

    let pic = await setBase64File(file)
    setCoverPic(pic)
  }

  const onActionClick = async (evt) => {
    if(!event?._id) {
      return
    }

    const axiosCustom = await createAxiosInstance()
    if(evt == 'delete') {
      await axiosCustom.delete('/event/'+event._id)
      callback('delete')
    }
    
    if(evt == 'archive') {
      await axiosCustom.put('/event/archive/'+event._id)
      callback('archive')
    }
  }
   
  useEffect(() => {
    getEvent(id)
  }, [id])

  useEffect(() => {
    setTypeOpts(typeData)
  
  }, [typeData])

  useEffect(() => {
    setCategoryList(event.type)
    
  }, [event.type])

  
  return (
    <div ref={modalRef}>
    <div className="modal-header fx fx-col">
      <h3>{'Event'}</h3>
      <div className='modal-tabs w100' onClick={e=> onSelectTab(e)}>
        <span name="general" className='modal-tab' selected={true}>{t('general')}</span>
        <span name="location" className='modal-tab'>{t('location_time')}</span>
        <span name="details" className='modal-tab'>{t('details')}</span>
      </div>
    </div>
     
    <form ref={formRef} className="modal-content">
      <div id="content.general" className="content-list">
        <div className="modal-multi-sect">
          <div className="modal-sect fx3">
            <label className="modal-lab">{t("name")}</label>
            <input className="modal-inp dark" value={event.name} onChange={(e) => setEventState(e.target.value, 'name')} required />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("type")}</label>
            <AutoComplete objKey="type" className="modal-inp dark" options={typeOpts} defaultValue={event.type} setValue={setEventState} required={true} />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("category")}</label>
            <AutoComplete objKey="category" className="modal-inp dark" options={categoryOpts} defaultValue={event.category} setValue={setEventState} required={true} />
          </div>
        </div>
        <div className="modal-multi-sect">
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("mood")}</label>
            <AutoComplete objKey="mood" className="modal-inp dark" options={moodOpts} defaultValue={event.mood} setValue={setEventState} required={true} />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("privacy_option")}</label>
            <AutoComplete objKey="privacyOption" className="modal-inp dark" options={privacyOptionOpts} defaultValue={event.privacyOption} setValue={setEventState} required={true} />
          </div>
        </div>
        <div className="modal-sect">
          <label className="modal-lab">{t("description")}</label>
          <textarea className="modal-inp dark txtarea" rows="10" style={{height:"auto"}} value={event.description} onChange={(e) => setEventState(e.target.value, 'description')} />
        </div>
      </div>

      <div id="content.location" className="content-list" hidden>
        <div className="modal-multi-sect">
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("location")}</label>
            <AutoCompleteAdress objKey="location" className="modal-inp dark" defaultValue={event.location} setValue={setEventState} required={true} />
          </div>
          <div className="modal-sect checkbox-sect">
            <label className="modal-lab">{t('hide_address')}</label>
            <input type="checkbox" name="hideAddress" className="switch" checked={event.hideAddress} onChange={(e) => setEventState(e.target.checked, 'hideAddress')} />
          </div>
        </div>
        <div className="modal-sect fx1">
          <label className="modal-lab">{t("meeting_location")}</label>
          <AutoCompleteAdress objKey="meetingLocation" className="modal-inp dark" defaultValue={event.meetingLocation} setValue={setEventState} />
        </div>
        <div className="modal-multi-sect">
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("from")}</label>
            <DatePickerCustom className="modal-inp dark date-picker" objKey="from" value={event.from} onChange={setEventState} time={true} />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("to")}</label>
            <DatePickerCustom className="modal-inp dark date-picker" objKey="to" value={event.to} onChange={setEventState} time={true} />
          </div>
        </div>
      </div>

      <div id="content.details" className="content-list" hidden>
        <div className="modal-multi-sect">
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("max_member")}</label>
            <input className="modal-inp dark" type="number" value={event.maxMember} onChange={(e) => setEventState(e.target.value, 'maxMember')} />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("min_age")}</label>
            <input className="modal-inp dark" type="number" value={(event.participantsFilter?.minAge || '')} onChange={(e) => setEventState(e.target.value, 'minAge')} />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("gender")}</label>
            <AutoComplete objKey="gender" className="modal-inp dark" options={genderOpts} defaultValue={event.participantsFilter?.gender} setValue={setEventState} />
          </div>
        </div>
        <div className="modal-multi-sect">
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("price")}</label>
            <input className="modal-inp dark" type="number" value={(event.price?.value || '')} onChange={(e) => setEventState(e.target.value, 'value')} />
          </div>
          <div className="modal-sect fx1">
            <label className="modal-lab">{t("paid_by")}</label>
            <AutoComplete objKey="paidBy" className="modal-inp dark" options={paidByOpts} defaultValue={event.price?.paidBy} setValue={setEventState} />
          </div>
        </div>

        <div className="modal-photo-wrap" style={{marginTop:'32px'}}>
          {!hasImg &&
          <label htmlFor="photo-upload" className="upload-container">
            <input type="file" id="photo-upload" accept="image/*" className="upload-input" onChange={e => onChangeImg(e.target)} />
            
            <div className="upload-placeholder">
              <span className="upload-text">{t('click_upload_photo')}</span>
            </div>
          </label>}

          {hasImg && 
          <div className="preview-container">
            <img ref={imgRef} alt="Uploaded preview" className="preview-image" />
            <button type="button" className="remove-btn" title="Remove photo" onClick={e => removeImg(e)}>X</button>
          </div>}
        </div>
      </div>
    </form>

    <div className="modal-btns absolute">
      <button className="bt" onClick={() => onSave()}>{t('save')}</button>
      <button className="bt bt-cancel" onClick={() => onCancel()}>{t('cancel')}</button>
      { conditions.showDelete && <span title={t('delete')} className="action-bt" onClick={() => onActionClick('delete')}><TrashIcon /></span> }
      { conditions.showArchive && <span title={t('end')} className="action-bt wo-fill" onClick={() => onActionClick('archive')}><ArchiveIcon /></span> }
    </div>
    </div>
  );
}

export default EventEditor
